<div class="mx-auto bg-base-100 rounded-lg sm:w-96 p-5">
    <div class="flex flex-row w-full justify-between items-center gap-4">
        <span class="text-lg font-bold" i18n>Change logo</span>
        <button mat-dialog-close class="btn btn-ghost btn-sm btn-circle">
            <iota-icon icon="x-mark"></iota-icon>
        </button>
    </div>

    <div *ngIf="!previewImageSrc" class="flex justify-center mt-10">
        <div class="avatar items-start w-32 mt-10" *ngIf="(localLogo$ | ngrxPush)?.url && !(localLogo$ | ngrxPush)?.loading">
            <div class="border border-base-200 p-2">
                <img [src]="(localLogo$ | ngrxPush)?.url" class="!object-contain" />
            </div>
        </div>
    </div>

    <div *ngIf="previewImageSrc" class="flex justify-center mt-10">
        <img [src]="previewImageSrc" class="w-32 mt-10 h-32 object-contain rounded-lg border border-base-200" />
    </div>

    <div
        class="flex justify-center mt-10 avatar placeholder"
        *ngIf="!(localLogo$ | ngrxPush)?.url && !(localLogo$ | ngrxPush)?.loading && !previewImageSrc"
    >
        <div class="avatar items-start w-32 rounded-lg border border-base-200 bg-neutral text-neutral-content">
            <span class="uppercase p-4" i18n>Logo</span>
        </div>
    </div>

    <div class="flex justify-center gap-5 text-sm font-semibold mt-5">
        <div class="flex gap-2 items-center cursor-pointer">
            <iota-icon icon="arrow-up-tray"></iota-icon>
            <label for="logoFileInput" class="cursor-pointer" i18n>Upload</label>
        </div>

        <input type="file" id="logoFileInput" #fileInput (change)="onLogoSelect($event)" accept="image/*" hidden />

        <button
            [ngClass]="{ 'text-base-300': previewImageSrc }"
            [disabled]="previewImageSrc"
            class="flex gap-2 items-center text-sm font-semibold"
            (click)="deleteLogo()"
        >
            <iota-icon icon="trash"></iota-icon>
            <span i18n>Remove</span>
        </button>
    </div>

    <div class="flex justify-end gap-3 mt-20 items-center">
        <button *ngIf="previewImageSrc" class="flex gap-1 items-center btn btn-outline btn-ghost" (click)="onCancelClick()">
            <span i18n>Cancel</span>
        </button>
        <button [disabled]="!previewImageSrc" (click)="save()" class="flex gap-1 items-center btn btn-secondary">
            <span i18n>Save</span>
        </button>
    </div>
</div>
